(function () {
  var V5 = '44541495148631', V8 = '44541495345239', V11 = '44541495476311';
  /* tier order on the page: 11-piece, 8-piece (Most Popular), 5-piece */
  var MAP = [[V11, 1], [V8, 1], [V5, 1]];

  /* ---- set selection ---- */
  var tiers = [].slice.call(document.querySelectorAll('.aw-hero-bundle'));
  /* the free gift only comes with the 10-piece (index 0) and 7-piece (index 1) sets, not the 5-piece set */
  var giftEls = [].slice.call(document.querySelectorAll('.aw-hero-countdown, .aw-hero-included-head, .aw-hero-included-sub, .aw-hero-gift'));
  var hint = document.createElement('p');
  hint.className = 'aw-hero-included-sub aw-gift-hint';
  hint.textContent = 'Choose the 7-Piece or 10-Piece Set to get a free Utensil Holder';
  hint.style.setProperty('display', 'none', 'important');
  if (giftEls.length) giftEls[giftEls.length - 1].parentNode.insertBefore(hint, giftEls[giftEls.length - 1].nextSibling);
  function pick(i) {
    tiers.forEach(function (t, k) { t.classList.toggle('aw-sel', k === i); });
    var hasGift = i <= 1;
    giftEls.forEach(function (el) { if (hasGift) el.style.removeProperty('display'); else el.style.setProperty('display', 'none', 'important'); });
    if (hasGift) hint.style.setProperty('display', 'none', 'important'); else hint.style.removeProperty('display');
    var m = MAP[i];
    [].slice.call(document.querySelectorAll('a[data-js-buy]')).forEach(function (a) {
      a.setAttribute('href', '/cart/' + m[0] + ':' + m[1]);
    });
  }
  tiers.forEach(function (t, i) { t.addEventListener('click', function () { pick(i); }); });
  if (tiers.length) pick(1);

  /* ---- gift countdown: 20 minutes per visitor, remembered across refreshes, restarts when it reaches zero ---- */
  (function () {
    var el = document.querySelector('.aw-hero-countdown');
    if (!el) return;
    var txt = el.textContent;
    var re = /[0-9]{1,2}:[0-9]{2}(:[0-9]{2})?/;
    if (!re.test(txt)) return;
    var LEN = 20 * 60 * 1000, KEY = 'spatula_gift_end';
    function load() { try { return parseInt(localStorage.getItem(KEY), 10) || 0; } catch (e) { return 0; } }
    function save(v) { try { localStorage.setItem(KEY, String(v)); } catch (e) {} }
    var end = load();
    if (end - Date.now() <= 0 || end - Date.now() > LEN) { end = Date.now() + LEN; save(end); }
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var ms = end - Date.now();
      if (ms <= 0) { end = Date.now() + LEN; save(end); ms = LEN; }
      var s = Math.ceil(ms / 1000);
      el.textContent = txt.replace(re, pad(Math.floor(s / 60)) + ':' + pad(s % 60));
    }
    tick();
    window.prcTimer = setInterval(tick, 1000);
  })();

  /* ---- UGC videos: tap a frame to play / pause ---- */
  (function () {
    var urls = [
      'https://cdn.shopify.com/s/files/1/0680/5064/9175/files/spatula-ugc-1.mp4?v=1792655374',
      'https://cdn.shopify.com/s/files/1/0680/5064/9175/files/spatula-ugc-2.mp4?v=1792655374',
      'https://cdn.shopify.com/s/files/1/0680/5064/9175/files/spatula-ugc-3.mp4?v=1792655374'
    ];
    var boxes = [].slice.call(document.querySelectorAll('.aw-hero-ugc-item'));
    var st = document.createElement('style');
    st.textContent = '.aw-root .aw-hero-ugc-item{overflow:hidden !important;cursor:pointer}' +
      '.aw-ugc-vid{position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;display:block;background:#fae6dc}' +
      '.aw-ugc-play{position:absolute;top:50%;left:50%;width:44px;height:44px;margin:-22px 0 0 -22px;border-radius:50%;background:rgba(0,0,0,.55);z-index:2;pointer-events:none}' +
      '.aw-ugc-play::before{content:"";position:absolute;top:13px;left:17px;border-style:solid;border-width:9px 0 9px 15px;border-color:transparent transparent transparent #fff}' +
      '.aw-ugc-playing .aw-ugc-play{display:none}';
    document.head.appendChild(st);
    var vids = [];
    boxes.forEach(function (box, i) {
      if (!urls[i]) return;
      var v = document.createElement('video');
      v.className = 'aw-ugc-vid';
      v.src = urls[i] + '#t=0.3';
      v.preload = 'metadata';
      v.loop = true;
      v.playsInline = true;
      v.controls = false;
      v.setAttribute('playsinline', '');
      v.setAttribute('aria-label', 'Customer video ' + (i + 1));
      var p = document.createElement('span');
      p.className = 'aw-ugc-play';
      box.appendChild(v);
      box.appendChild(p);
      vids.push(v);
      box.addEventListener('click', function () {
        if (v.paused) {
          vids.forEach(function (o) { if (o !== v) { o.pause(); o.parentNode.classList.remove('aw-ugc-playing'); } });
          v.muted = false;
          var r = v.play();
          if (r && r.catch) r.catch(function () { v.muted = true; v.play(); });
          box.classList.add('aw-ugc-playing');
        } else {
          v.pause();
          box.classList.remove('aw-ugc-playing');
        }
      });
    });
  })();

  /* ---- FAQ: click to open / close ---- */
  [].slice.call(document.querySelectorAll('.aw-faq-row')).forEach(function (row) {
    row.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.aw-faq-row-answer')) return;
      var open = row.classList.toggle('aw-open');
      var ic = row.querySelector('.aw-faq-icon');
      if (ic) ic.textContent = open ? String.fromCharCode(8722) : '+';
    });
  });

  /* ---- product gallery: thumbnails switch the main photo ---- */
  (function () {
    var main = document.querySelector('.aw-hero-image');
    var thumbs = [].slice.call(document.querySelectorAll('.aw-hero-thumb'));
    if (!main || !thumbs.length) return;
    function show(i) {
      main.style.setProperty('background-image', getComputedStyle(thumbs[i]).backgroundImage, 'important');
      thumbs.forEach(function (t, k) { t.classList.toggle('aw-thumb-on', k === i); });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    show(0);
  })();

  /* ---- footer: use the store's homepage footer (isolated frame, no scripts / tracking) ---- */
  (function () {
    var anchor = document.querySelector('.aw-root');
    if (!anchor) return;
    fetch('/', { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var all = [].slice.call(doc.querySelectorAll('.shopify-section-group-footer-group'));
      if (!all.length) return;
      var grp = doc.createElement('div');
      grp.className = 'tb-footer-wrap';
      [].slice.call(doc.querySelectorAll('script,noscript,iframe')).forEach(function (e) { e.parentNode.removeChild(e); });
      var base = doc.createElement('base');
      base.setAttribute('href', location.origin + '/');
      base.setAttribute('target', '_top');
      doc.head.insertBefore(base, doc.head.firstChild);
      var stl = doc.createElement('style');
      stl.textContent = 'html,body{margin:0 !important;padding:0 !important;overflow:hidden !important}';
      doc.head.appendChild(stl);
      doc.body.innerHTML = '';
      all.forEach(function (e) { grp.appendChild(e); });
      doc.body.appendChild(grp);
      var frame = document.createElement('iframe');
      frame.setAttribute('title', 'Footer');
      frame.setAttribute('scrolling', 'no');
      frame.style.cssText = 'display:block;width:100%;border:0;height:300px';
      frame.srcdoc = '<!doctype html>' + doc.documentElement.outerHTML;
      function fit() {
        try {
          var g = frame.contentDocument.querySelector('.tb-footer-wrap');
          if (g) frame.style.height = Math.ceil(g.getBoundingClientRect().height) + 'px';
        } catch (e) {}
      }
      frame.addEventListener('load', function () {
        fit();
        try { new ResizeObserver(fit).observe(frame.contentDocument.querySelector('.tb-footer-wrap')); } catch (e) {}
        setTimeout(fit, 400); setTimeout(fit, 1500);
      });
      window.addEventListener('resize', fit);
      var old = document.querySelector('.aw-root > footer');
      if (old) { old.parentNode.insertBefore(frame, old); old.style.display = 'none'; }
      else anchor.parentNode.insertBefore(frame, anchor.nextSibling);
    }).catch(function () {});
  })();
})();
